import { css, keyframes } from 'styled-components';

/*
 * Silhouette only. Every stop sums to 100% along each edge — otherwise the browser
 * rescales the radii and the closed organic curve falls apart into a rounded rect.
 */
export const morph = keyframes`
  0%, 100% { border-radius: 42% 58% 63% 37% / 41% 44% 56% 59%; }
  25% { border-radius: 70% 30% 38% 62% / 63% 68% 32% 37%; }
  50% { border-radius: 33% 67% 55% 45% / 48% 30% 70% 52%; }
  75% { border-radius: 58% 42% 30% 70% / 35% 55% 45% 65%; }
`;

/*
 * Rotation and scale, kept deliberately gentle. A wide swing spins the off-centre
 * gradient highlight with it, which reads as a turntable rather than a shape-shifter.
 */
export const drift = keyframes`
  0%, 100% { transform: rotate(0deg) scale(1); }
  33% { transform: rotate(9deg) scale(1.05); }
  66% { transform: rotate(-7deg) scale(0.97); }
`;

/** Run the two on coprime-ish periods so the pair never settles into a visible loop. */
export const blob = (morphSeconds: number, driftSeconds: number) => css`
  animation: ${morph} ${morphSeconds}s ease-in-out infinite,
    ${drift} ${driftSeconds}s ease-in-out infinite;
`;

export const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-22px); }
`;

export const marquee = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

export const shift = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(0, -30px) scale(1.05); }
`;

export const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const EASE = 'cubic-bezier(.2, .7, .2, 1)';

export const REVEAL_TRANSITION = `opacity .9s ${EASE}, transform .9s ${EASE}`;

/**
 * Hidden until `data-revealed` lands on the element. Applied by <Reveal>, which
 * flips the attribute once the element scrolls into view.
 */
export const revealBase = css`
  opacity: 0;
  transform: translateY(30px);
  transition: ${REVEAL_TRANSITION};

  &:not([data-revealed]) {
    will-change: opacity, transform;
  }

  &[data-revealed] {
    opacity: 1;
    transform: none;
  }
`;
